import React, { useState, useEffect } from 'react'
import NumberInput from '../../../../elements/NumberInput/NumberInput'
import {
  checkForEmpty,
  checkOnlyDot,
  checkRegEx,
} from '../../../helpers/checkers'
import { regexes } from '../../../helpers/regex'
import {
  SwitcherArea,
  SwitcherBox,
  SwitcherCheck,
  SwitcherWrapper,
} from './SwitcherStyles'
import floorFigure from '../../../helpers/floorFigure'
import { SFXS } from '@orbital/games-frontend-library'

export default function Switcher({
  handleChance,
  handleSwitch,
  value,
  title,
  checked,
  name,
  audio,
}: any) {
  const [chanceValue, setChanceValue] = useState(value)
  
  const handleChange = (e: any) => {
    let val = e.target.value
    if (val.includes('%')) {
      val = val.split('%')[0]
    }
    if (checkRegEx(val, regexes.numbersDotComma)) {
      setChanceValue(val.replace(/,/g, '.'))
    }
  }
  const onChange = () => {
    !audio.isSoundOff && SFXS.switchSFX.play()
    handleSwitch(checked)
  }
  const maxValue = 9999
  const handleBlur = (s: any) => {
    let val = s.target.value
    if (checkForEmpty(val) || checkOnlyDot(val)) {
      return handleChance('0.00', `${name}_PERCENT`), setChanceValue('0.00%')
    }
    if (+val > maxValue) {
      return (
        setChanceValue(`${floorFigure(maxValue.toString(), 2)}%`),
        handleChance(floorFigure(maxValue.toString(), 2), `${name}_PERCENT`)
      )
    }
    if (val.includes('%')) {
      return (val = val.split('%')[0])
    }
    if (!val.includes('%')) {
      return (
        setChanceValue(`${floorFigure(chanceValue, 2)}%`),
        handleChance(floorFigure(chanceValue, 2), `${name}_PERCENT`)
      )
    }
    return (
      setChanceValue(`${floorFigure(val, 2)}%`),
      handleChance(floorFigure(val, 2), `${name}_PERCENT`)
    )
  }
  useEffect(() => {
    setChanceValue(`${floorFigure(value, 2)}%`)
    handleChance(value, `${name}_PERCENT`)
  }, [value])
  return (
    <SwitcherWrapper className='switcher'>
      <NumberInput
        value={chanceValue}
        handleBlur={handleBlur}
        handleChange={handleChange}
        title={title}
        switchText={checked ? 'INCREASE' : 'RESET'}
        placeholder={'50.00%'}
        checked={checked}
      />
      <SwitcherArea onClick={() => onChange()}>
        <SwitcherBox>
          <SwitcherCheck checked={checked} />
        </SwitcherBox>
      </SwitcherArea>
    </SwitcherWrapper>
  )
}
